<template>
    <div class="authenticate-panel grid xs-grid-cols-1 gap-3">
        <template v-if="!isUserExist">
            <div class="text-center">
                <i class="circle huge signin-header-logo"></i>
            </div>
            <div class="text-center">
                <h3 class="f3 text-bold">Welcome Back </h3>
                <div class="f5 text-bold">Sign in to access your account.</div>
            </div>
        </template>
        <template v-else-if="showCodeLogin">
            <h3 class="f3 text-bold">We sent you a code</h3>
            <p class="f5">
                Please enter the 6-digit code we sent to
                <span class="text-bold">{{ username }}</span>
            </p>
        </template>
        <template v-else>
            <div>
                <h3 class="f3 text-bold">Enter your password</h3>
            </div>
        </template>
        <form class="form form-default grid xs-grid-cols-1 gap-3" :class="formState" v-submit="submit" novalidate>
            <mvtTextbox v-if="!isUserExist">
                <div class="input">
                    <label>Email</label>
                    <input type="email" name="username" v-model="username" v-validate="'required|email'"/>
                </div>
            </mvtTextbox>
            <mvtTextbox v-if="!showCodeLogin">
                <div class="input">
                    <label>Password</label>
                    <input type="password" data-dd-privacy="mask-user-input" ref="password" name="password" v-model="password" v-validate="'required'"/>
                </div>
            </mvtTextbox>
            <template v-if="showCodeLogin">
                <div class="passcode-field">
                    <ul class="passcode-field-digits">
                        <li
                            v-for="index in 6"
                            :key="index"
                            :class="{ active: passcodeFocused && localPasscode.length === index - 1 }"
                        >
                            {{ localPasscode[index - 1] || '' }}
                        </li>
                    </ul>
                    <input
                        ref="passcodeInput"
                        type="tel"
                        name="passcode"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        :value="localPasscode"
                        maxlength="6"
                        autocomplete="one-time-code"
                        placeholder="Enter 6-digit code"
                        @input="onPasscodeInput"
                        @focus="passcodeFocused = true"
                        @blur="passcodeFocused = false"
                    />
                </div>
                <p v-if="showResendCode" class="f6 text-gray">
                    Didn't get a code?
                    <button
                        v-if="canResend"
                        type="button"
                        class="link text-bold"
                        :disabled="sendingCode"
                        @click="onResendCode"
                    >
                        Resend
                    </button>
                    <span v-else>Resend in {{ resendCountdown }}</span>
                </p>
            </template>
            <div v-if="errorMsg" class="text-error f7" v-html="errorMsg"></div>
            <div v-if="!showCodeLogin" class="flex">
                <a class="link" @click="switchComponent('mvtForgetPassword')">Forgot password?</a>
            </div>
            <button
                v-if="showCodeLogin"
                class="btn primary large"
                type="submit"
                :disabled="!canContinueWithCode"
            >
                Continue
            </button>
            <button v-else class="btn primary large" type="submit">Continue With Email</button>
            <template v-if="!isUserExist">
                <div class="login-alternate">
                    <hr>or<hr>
                </div>
                <mvtSocial :trigger="options.trigger" :requestName="options.requestName"/>
            </template>
            <div v-else-if="showCodeLogin" class="text-center">
                <a class="link text-bold" @click="onUsePassword">Use Password</a>
            </div>
            <div v-else-if="!isActivated" class="text-center">
                <a class="link text-bold" @click="onSendCode">Send Me A Code</a>
            </div>
        </form>
    </div>
</template>
<script src="./mvt-emaillogin.js"></script>
